var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":("/img/be/" + (this.targa) + "/logo.svg")},on:{"error":_vm.fallbackImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }